module.exports = __webpack_public_path__ + "img/logo.a05d9b0a.png";